import { render } from "./view_all_birthdays.html?vue&type=template&id=78f94627&external"
import script from "./view_all_birthdays.js?vue&type=script&lang=js&external"
export * from "./view_all_birthdays.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__